<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import {
    AppState,
    SetIconsBackground,
    SetNotification
  } from '../../../etc/stores';
  import CouponUnexpectedErrorIcon from '../../icons/CouponUnexpectedErrorIcon.svelte';
  import MessagePopup from '../../misc/MessagePopup.svelte';
  import ThemedIcon from '../../misc/ThemedIcon.svelte';
  import Button from '../../form/Button.svelte';
  import Link from '../../misc/Link.svelte';
  import Close from '../../icons/Close.svelte';
  import { Container } from '../../../services/container';
  import { FreeCoinsCampaign } from '../../../services/free-coins-campaign';
  import { Logger } from '../../../services/logger';
  import { extractSlugFromError } from '../../../services/api';
  import Analytics from '../../../services/analytics';
  import PoweredBy from '../../misc/PoweredBy.svelte';
  import { replaceVariables } from '../../../i18n';
  import Heading from '../../typography/Heading.svelte';
  import Text from '../../typography/Text.svelte';

  const freeCoinsCampaign = Container.get(
    FreeCoinsCampaign
  ) as FreeCoinsCampaign;
  const logger = Container.get(Logger).context(
    'WelcomeCoinAvailable.svelte'
  ) as Logger;

  const description = $AppState.website.notificationParams?.description;
  const isCustomAction = !!$AppState.website.notificationParams?.claimAction;
  const claimAction =
    $AppState.website.notificationParams?.claimAction ||
    (() =>
      freeCoinsCampaign.claimCampaignCoupon({
        analyticsCategory: 'free-coins-state'
      }));

  let loading = false;

  const t = (text: string, values: any = {}) => {
    return replaceVariables(
      $_(`welcome_coin_unexpected_error_popup.${text}`),
      values
    );
  };

  const closeMessage = () => {
    SetNotification('');
  };

  const tryClaimAgain = async () => {
    loading = true;

    try {
      await claimAction();

      if (!isCustomAction) SetNotification('paymentCoinSaved', true);
    } catch (err) {
      const errorModal = freeCoinsCampaign.getNotificationByErrorSlug(
        extractSlugFromError(err)
      );

      if (errorModal === 'paymentCoinUnexpectedError') {
        loading = false;
        logger.error(err);
      } else {
        SetNotification(errorModal, true);
      }

      if (err.status != 400) {
        logger.error(err);
      }
    }
  };

  onMount(() => {
    SetIconsBackground('light-without-background');
    Analytics.logEvent('claim-error-unexpected-error', 'free-coins-state');
  });
</script>

<MessagePopup>
  <div class="welcome-coin-unexpected-error--wrapper">
    <div class="welcome-coin-unexpected-error--close" on:click={closeMessage}>
      <ThemedIcon>
        <Close />
      </ThemedIcon>
    </div>
    <CouponUnexpectedErrorIcon />
    <div class="welcome-coin-unexpected-error--content">
      <Heading type="h2" textAlign="center">
        {@html t('title')}
      </Heading>
      <Text type="default" textAlign="center">
        {description ||
          t('description', { firstName: $AppState.customer.name })}
      </Text>
    </div>
    <Button label={t('btn')} on:click={tryClaimAgain} {loading} />
    <div class="welcome-coin-unexpected-error--link">
      <Link fontSize="14px" lineHeight="20px" href="mailto:support@twism.com">
        {t('link')}
      </Link>
    </div>
    <PoweredBy />
  </div>
</MessagePopup>

<style lang="scss">
  @use './styles.scss' as *;

  .welcome-coin-unexpected-error {
    &--wrapper {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      width: 100%;
      padding: 24px 16px 0;
      box-sizing: border-box;
    }

    &--content {
      :global(h2) {
        margin-top: 16px !important;
      }

      :global(p) {
        margin-top: 16px !important;
        margin-bottom: 24px !important;
      }
    }

    &--link {
      margin: 24px 0;
    }

    &--close {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
  }
</style>
